module.exports = __webpack_public_path__ + "static/social-2a-c81d50b606462c9f88be09a3ddda00ec.svg";